import { Component, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { TabComponent } from '../tab/tab.component';

@Component({
  selector: 'prcins-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css']
})
export class TabsComponent implements AfterContentInit  {

  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;

  ngAfterContentInit() {
    // Get all active tabs
    const activeTabs = this.tabs.filter(tab => tab.active);

    // If there is no active tab set, activate the first one
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
  }

  selectTab(tab: TabComponent) {
    // Deactivate all tabs
    this.tabs.toArray().forEach(t => t.active = false);

    // Activate the tab the user has clicked on
    tab.active = true;
  }
}
